import React from 'react';
import UseContext from "hooks/useContext";
import StyledInput from "components/styledInput/StyledInput";
import SectionWrapper from "../components/SectionWrapper";

const INSTRUCTIONS_MAX_LENGTH = 500;

// "Détails" step: instructions that belong to this mission only. They start from the
// template's own instructions (copied by createOfMission.js) and never write back to it.
const Other = () => {
    const {data, setData, language} = UseContext()
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.details.${key}`, defaultValue)

    return (
        <SectionWrapper
            title={label('title', 'Consignes')}
            description={label(
                'description',
                'Propres à cette mission, elles ne modifient pas la fiche de poste.'
            )}
        >
            <StyledInput
                type="textarea"
                label={label('tempWorker', 'Pour l\'intérimaire')}
                value={data.other ?? ''}
                maxLength={INSTRUCTIONS_MAX_LENGTH}
                placeholder={label(
                    'tempWorkerPlaceholder',
                    'Ex : L\'entrée des employés se trouve sur la porte à gauche de l\'enseigne'
                )}
                onChange={(e) => {
                    const other = e.target.value
                    setData(prevData => ({...prevData, other}))
                }}
            />
            <StyledInput
                type="textarea"
                label={label('jobbiz', 'Pour l\'équipe Jobbiz')}
                value={data.other_interim ?? ''}
                maxLength={INSTRUCTIONS_MAX_LENGTH}
                placeholder={label('jobbizPlaceholder', 'Ex : profil autonome souhaité')}
                onChange={(e) => {
                    const other_interim = e.target.value
                    setData(prevData => ({...prevData, other_interim}))
                }}
            />
        </SectionWrapper>
    );
};

export default Other;
